import { useQuery } from "@tanstack/react-query";

import type { User } from "@luna-restaurant/school-api";

import { useAccessToken } from "@/hooks/useAccessToken";
import { useRequest } from "@/hooks/useRequest";

export const useCurrentUser = () => {
  const request = useRequest();
  const { token, payload, isLoading: isLoadingToken } = useAccessToken();
  const userId = payload?.sub ?? null;

  const { data: currentUser, isLoading: isLoadingUser } = useQuery<User | null>(
    {
      queryKey: ["currentUser", userId],
      staleTime: 4 * 60 * 60 * 1000, // 4 hours
      enabled: Boolean(token) && Boolean(userId),
      queryFn: async () => {
        const user = await request<User>(`/v1/users/${userId!}`);
        return user ?? null;
      },
    },
  );

  return {
    currentUser: currentUser ?? null,
    isLoadingUser: isLoadingToken || isLoadingUser,
  };
};
